import React, { useState, ForwardRefRenderFunction, useImperativeHandle } from "react";
import { useTranslation } from "react-i18next";
import { Warning2 as WarningIcon } from "iconsax-react";

import ConfirmationModal from "Components/Dialogs/ConfirmationModal";
import { Color } from "Components/Form/Button";

export interface ConfirmChangeModalHandle {
  open: ({ cancelWithReverseResource }?: { cancelWithReverseResource: boolean }) => void;
  close: (withReverse?: boolean) => void;
}

interface Props {
  onSubmit: () => void;
  onReverseResources: () => void;
  children: React.ReactNode;
  loading?: boolean;
}

const ConfirmChangeModal: ForwardRefRenderFunction<ConfirmChangeModalHandle, Props> = (
  { onSubmit, onReverseResources, loading = false, children },
  ref
) => {
  const { t: translate } = useTranslation();

  const [openModal, setOpenModal] = useState(false);
  const [withReverseResource, setWithReverseResource] = useState(true);

  const returnConfirmationModalTitle = () => {
    const titles = translate("saveChanges").split(" ");
    return titles[0].concat(` ${titles[1].toLowerCase()}`);
  };

  useImperativeHandle(ref, () => ({
    open: (props) => {
      if (props?.cancelWithReverseResource)
        setWithReverseResource(props?.cancelWithReverseResource);
      setOpenModal(true);
    },
    close: (withReverse = false) => {
      if (withReverse) onReverseResources();
      setOpenModal(false);
    },
  }));

  return (
    <ConfirmationModal
      width="480px !important"
      open={openModal}
      closeModal={() => {
        if (withReverseResource) onReverseResources();
        setOpenModal(false);
      }}
      type="warning"
      title={returnConfirmationModalTitle()}
      leftIconTitle={<WarningIcon color="#F79009" size={20} />}
      textCancel={translate("cancel")}
      textSubmit={translate("save")}
      customColorSave={Color.SUCCESS}
      submit={onSubmit}
      loading={loading}
    >
      {children}
    </ConfirmationModal>
  );
};

const ConfirmChangeModalComponent = React.forwardRef(ConfirmChangeModal);

export { ConfirmChangeModalComponent };
